import { useContext, useEffect, useState } from 'react';
import { TenantConfigContext } from 'context/TenantConfigContext';
import { useIntl } from 'react-intl';
import { IntlContext } from 'context/LocalisationContext';
import { formatRelative } from 'date-fns';
import { Chip } from '@mui/material';
import { tbPalette } from 'styles/colors';
import { getChipSxStylingForLevel } from 'styles/utils';

export function LastUpdatedChip() {
  const intl = useIntl();
  const { currentDataVersion } = useContext(TenantConfigContext);

  const {
    currentConfig: { dateFnsLocale },
  } = useContext(IntlContext);

  const [lastUpdateInfo, setLastUpdateInfo] = useState({
    available: false,
    lastUpdateText: '',
    chipBgColour: tbPalette.background.highlight,
    chipTextColour: tbPalette.ui.highlight,
  });

  const [updateOverdue, setUpdateOverdue] = useState(false);

  useEffect(() => {
    // mark Update overdue if it is not existent or if it was more than 25 hours ago
    setUpdateOverdue(!currentDataVersion || (Date.now() - currentDataVersion.getTime()) / 1000 / 60 / 60 > 25);
  }, [currentDataVersion]);

  useEffect(() => {
    const lastUpdateText = currentDataVersion
      ? intl.formatMessage(
          { id: 'last.data.update', defaultMessage: 'updated ' },
          {
            relativeTime: formatRelative(currentDataVersion, new Date(), {
              locale: dateFnsLocale,
            }),
          }
        )
      : '';

    setLastUpdateInfo({
      available: !!currentDataVersion,
      lastUpdateText,
      chipBgColour: updateOverdue ? tbPalette.background.warning : tbPalette.background.highlight,
      chipTextColour: updateOverdue ? tbPalette.ui.warning : tbPalette.ui.highlight,
    });
  }, [currentDataVersion, dateFnsLocale, updateOverdue, intl]);

  return <Chip sx={getChipSxStylingForLevel('Information')} label={lastUpdateInfo.lastUpdateText} />;
}
